<template>
  <div :class="{ 'avalanche-danger-row': true, [`avalanche-danger-row--${priority}`]: true, 'break-avoid': true }">
    <h2 class="avalanche-danger-row__heading avalanche-danger-row__heading--priority">Avalanche Problem {{priority_level}}</h2>
    <div class="row">
      <div class="col-12 col-lg-2 col-print-2 pr-lg-0 mb-4">
        <div v-if="character" class="avalanche-danger-row__character">
          <img :src="character.iconUrl" :alt="character.title" />
        </div>
      </div>
      <div class="col-12 col-lg-10 col-print-10 pt-lg-4 pl-lg-4">
        <div class="row">
          <div v-if="description" class="col-12 mb-4">
            <h3 class="avalanche-danger-row__heading">Description</h3>
            <div class="mb-0" v-html="description"></div>
          </div>
        </div>

        <div class="row">
          <div v-if="trend" class="col-12 col-md-6 col-print-6 mb-4">
            <h3 class="avalanche-danger-row__heading">Trend</h3>
            <p :class="{ 'avalanche-danger-row__trend': true, [`avalanche-danger-row__trend--${trend}`]: true, 'mb-0': true }">{{ trend | niceTrend }}</p>
          </div>

          <div v-if="time && (time.start || time.end || time.isAllDay)" class="col-12 col-md-3 col-print-3 mb-4">
            <h3 class="avalanche-danger-row__heading">Time of Day</h3>
            <p class="mb-0">{{ time | niceTime }}</p>
          </div>

          <p v-if="moreInfoLink" class="col-12 col-md-3 hide-print">
            <a class="link" :href="moreInfoLink"><i class="fa fa-question-circle mr-1"></i>What does this mean?</a>
          </p>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-print-6 mb-4">
            <h3 class="avalanche-danger-row__heading">Dangerous Aspects</h3>
            <DangerRose :high="aspects.ha" :mid="aspects.a" :low="aspects.sa" />
          </div>

          <div v-if="likelihood" class="col-6 col-md-3 col-print-3">
            <h3 class="avalanche-danger-row__heading">Likelihood</h3>
            <Gauge :labels="['Almost Certain', 'Likely', 'Unlikely']" :value="likelihood" />
          </div>

          <div v-if="size" class="col-6 col-md-3 col-print-3">
            <h3 class="avalanche-danger-row__heading">Size</h3>
            <Gauge :labels="['Largest', 'Smallest']" :value="size" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DangerRose from '../danger-rose/DangerRose';
  import Gauge from '../gauge/Gauge';

  export default {
    components: {
      DangerRose,
      Gauge,
    },

    props: {
      priority: {
        type: String,
        required: true,
      },

      priority_level: {
        type: Number
      },

      character: {
        type: Object,
      },

      description: {
        type: String,
      },

      time: {
        type: Object,
      },

      trend: {
        type: String,
      },

      moreInfoLink: {
        type: String,
      },

      aspects: {
        type: Object,
        default() {
          return {};
        },
      },

      likelihood: {
        type: Number,
      },

      size: {
        type: Number,
      },
    },

    filters: {
      niceTime(value) {
        if (value.isAllDay) {
          return 'All Day';
        }

        const locale = 'en-NZ';
        let start = new Date();
        let end = new Date();

        start.setHours(value.start.split(':')[0]);
        end.setHours(value.end.split(':')[0]);

        start = start.toLocaleString(locale, { hour: 'numeric' });
        end = end.toLocaleString(locale, { hour: 'numeric' });

        return `Between ${start} - ${end}`;
      },

      niceTrend(value) {
        let trend;

        switch (value) {
          case 'Increasing':
            trend = 'Increasing';
            break;
          case 'NoChange':
            trend = 'No Change';
            break;
          case 'Decreasing':
            trend = 'Decreasing';
            break;
          default:
            trend = '';
        }

        return trend;
      },
    },
  };
</script>
